import React from 'react'

import { useMutation } from '@apollo/client'
import mutation from './mutation.graphql'

const withMutation = WrappedComponent => {
  return props => {
    const {
      onMutationCompleted, // via withFormResults
      onMutationError // via withFormResults
    } = props

    const [checkOut, { loading, error }] = useMutation(mutation, {
      onError: onMutationError,
      onCompleted: onMutationCompleted
    })

    return (
      <WrappedComponent
        checkOut={checkOut}
        mutationLoading={loading}
        error={error}
        {...props}
      />
    )
  }
}

export default withMutation
